import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  sendMessage: {
    method: 'POST',
    url: `${configs.baseUrl}/api/chat/messages`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sendMessage = async (params) => {
  await resource.sendMessage(params)
}

export default {
  initResource,
  sendMessage,
}
